"use strict";
/*
 * Created on 15. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var SelloutReleaseItemUpdateRequest_1 = require("../../model/sellout/SelloutReleaseItemUpdateRequest");

var SelloutReleaseItemKeyConverter_1 = require("./SelloutReleaseItemKeyConverter");

var SelloutReleaseItemUpdateConverter_1 = require("./SelloutReleaseItemUpdateConverter");

var SelloutReleaseItemUpdateRequestConverter_1 = require("./SelloutReleaseItemUpdateRequestConverter");
/**
 * @author Radek Beran
 */


var SelloutReleaseItemUpdateRequestConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseItemUp) {
  _inherits(SelloutReleaseItemUpdateRequestConverterImpl, _SelloutReleaseItemUp);

  function SelloutReleaseItemUpdateRequestConverterImpl(selloutReleaseItemKeyConverter, selloutReleaseItemUpdateConverter) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemUpdateRequestConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemUpdateRequestConverterImpl).call(this));
    _this.selloutReleaseItemKeyConverter = selloutReleaseItemKeyConverter;
    _this.selloutReleaseItemUpdateConverter = selloutReleaseItemUpdateConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutReleaseItemUpdateRequestConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutReleaseItemUpdateRequest_1.SelloutReleaseItemUpdateRequest(conversions.asObjectList(source, 'updates', function (doc) {
        return [_this2.selloutReleaseItemKeyConverter.toObject(doc[0], conversions), _this2.selloutReleaseItemUpdateConverter.toObject(doc[1], conversions)];
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {};
      result = Object.assign(result, {
        updates: conversions.asObjectArray(source, 'updates', function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              update = _ref2[1];

          return [_this3.selloutReleaseItemKeyConverter.toDocument(key, conversions), _this3.selloutReleaseItemUpdateConverter.toDocument(update, conversions)];
        })
      });
      return result;
    }
  }]);

  return SelloutReleaseItemUpdateRequestConverterImpl;
}(SelloutReleaseItemUpdateRequestConverter_1.SelloutReleaseItemUpdateRequestConverter);

SelloutReleaseItemUpdateRequestConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutReleaseItemKeyConverter_1.SelloutReleaseItemKeyConverter, SelloutReleaseItemUpdateConverter_1.SelloutReleaseItemUpdateConverter])], SelloutReleaseItemUpdateRequestConverterImpl);
exports.SelloutReleaseItemUpdateRequestConverterImpl = SelloutReleaseItemUpdateRequestConverterImpl;